import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "icon"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { ListboxOptionMedia } from '../ListboxOptionMedia/ListboxOptionMedia';
import { StyledListboxGroupLabel } from './ListboxGroupLabel.styles';

/**
 * A group label for the `Listbox` component.
 *
 * **Note:** This component is not meant to be used outside the context of a
 * `Listbox` `renderGroupLabel` callback.
 *
 * @since 8.28.0
 */
export var ListboxGroupLabel = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var mediaNode;
  if (icon) {
    mediaNode = /*#__PURE__*/React.createElement(ListboxOptionMedia, null, icon);
  }
  return /*#__PURE__*/React.createElement(StyledListboxGroupLabel, _extends({
    ref: forwardedRef,
    icon: icon
  }, rest), mediaNode, label);
});
ListboxGroupLabel.displayName = 'ListboxGroupLabel';
ListboxGroupLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The label text.
   */
  label: PropTypes.string.isRequired,
  /**
   * An optional `Icon` for the label.
   */
  icon: PropTypes.node,
  /**
   * Labels are given a [presentation](https://www.w3.org/TR/wai-aria-1.2/#presentation) role by
   * default.
   */
  role: PropTypes.string,
  /**
   * All groups require a label, but in some cases we might want to visually hide the label.
   * Note: It only really makes sense to hide the first group label, otherwise separate groups
   * will be visually grouped together.
   */
  visuallyHidden: PropTypes.bool
} : {};
ListboxGroupLabel.defaultProps = {
  role: 'presentation'
};